import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../../modules/common/services/api.config.json';

@Injectable({
  providedIn: 'root'
})
export class RegistroService {


  constructor(private _apiService: ApiService) {

  }

  GetAllRegistroByTypes(companyId: string, agenda: string, reunionesConSME: string, revisiones: string, visitasDeEmpresa: string): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getAllRegistroByTypes}`;
    url = url.replace('{companyId}', companyId);
    url = url.replace('{agenda}', agenda);
    url = url.replace('{reunionesConSME}', reunionesConSME);
    url = url.replace('{revisiones}', revisiones);
    url = url.replace('{visitasDeEmpresa}', visitasDeEmpresa);
    return this._apiService.get(url);
  }

  DeleteRegistro(id: number, type: string): Observable<RestResponse> {
    let url = `${API.CompanyManagement.deleteRegistro}`;
    url = url.replace('{id}', id.toString());
    url = url.replace('{tipo}', type);
    return this._apiService.delete(url);
  }

  //agenda
  GetAgendaById(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getAgendaById}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  AddAgenda(agenda: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.addAgenda}`;
    return this._apiService.post(url, agenda);
  }
  UpdateAgenda(agenda: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateAgenda}`;
    return this._apiService.put(url, agenda);
  }

  //visitia empresa
  GetVisitaEmpresaById(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getVisitaEmpresaById}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  AddVisitaEmpresa(agenda: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.addVisitaEmpresa}`;
    return this._apiService.post(url, agenda);
  }
  UpdateVisitaEmpresa(agenda: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateVisitaEmpresa}`;
    return this._apiService.put(url, agenda);
  }

  //reunion
  GetReunionSmeById(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getReunionSmeById}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }

  AddReunionSme(agenda: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.addReunionSme}`;
    return this._apiService.post(url, agenda);
  }
  UpdateReunionSme(agenda: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateReunionSme}`;
    return this._apiService.put(url, agenda);
  }

  //revision
  GetRevisionEmpresaById(id: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.getRevisionEmpresaById}`;
    url = url.replace('{id}', id);
    return this._apiService.get(url);
  }
  
  AddRevisionEmpresa(agenda: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.addRevisionEmpresa}`;
    return this._apiService.post(url, agenda);
  }
  UpdateRevisionEmpresa(agenda: any): Observable<RestResponse> {
    let url = `${API.CompanyManagement.updateRevisionEmpresa}`;
    return this._apiService.put(url, agenda);
  }


}
